import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { routingConstants } from '../../_constants/routing-constants.const';

@Component({
  selector: 'app-login',
  imports: [],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login {
  private readonly router = inject(Router);

  public login(): void {
    this.router.navigate([routingConstants.transcriber]);
  }
}
